export var API_CONFIG = {
    BASE_URL: 'https://xj2f572byb.execute-api.ap-northeast-1.amazonaws.com',
    ENDPOINTS: {
        REVIEWS: '/reviews',
        UPLOADS: '/uploads',
    }
};
